export enum PricingType {
  CALCULATED = 'calculated',
  MANUAL = 'manual',
}

export enum PricingSourceType {
  CORPORATE = 'corporate',
  CUSTOM = 'custom',
  CUSTOMER_CORPORATE = 'customer_corporate',
  CUSTOMER_QUOTE = 'customer_quote',
  DEFAULT = 'default',
  EXTERNAL = 'external',
  FAMILY = 'family',
  FLOOR_PRICE = 'floor_price',
  LIST_PRICE = 'list_price',
  PROJECT = 'project',
  // A hand-picked agreement: posted like CUSTOM, but never folded into the CUSTOM branches.
  SELECTED_SPA = 'selected_spa',
  UNSET = 'unset',
  VENDOR = 'vendor',
  VENDOR_QUOTE = 'vendor_quote',
}

export enum PricingSourceDiscountType {
  BASE_CODE = 'base_code',
  BASE_CODE_VENDOR_QUOTE_PART = 'base_code_vendor_quote_part',
  CURRENT_QUOTE_PART_DISCOUNT = 'current_quote_part_discount',
  CURRENT_QUOTE_PRICING_GROUP_DISCOUNT = 'current_quote_pricing_group_discount',
  DISCOUNT = 'discount',
  FIXED_COST = 'fixed_cost',
  FIXED_PRICE = 'fixed_price',
  MARGIN = 'margin',
  VENDOR_QUOTE_PART = 'vendor_quote_part',
  VENDOR_QUOTE_PART_DISCOUNT = 'vendor_quote_part_discount',
  VENDOR_QUOTE_PRICING_GROUP_DISCOUNT = 'vendor_quote_pricing_group_discount',
}

export enum PricingSourceStatus {
  PRICING_PROFILE_REMOVED = 'pricing_profile_removed',
}

export enum PricingProfileDetailsTab {
  ACCESS = 'access',
  ADMIN_USERS = 'admin-users',
  COSTING_CALCULATION = 'costing-calculation',
  DETAILS = 'details',
  DOCUMENTS = 'documents',
  PART_NUMBER_BASED = 'part-number-based',
  PROJECT_CUSTOMERS = 'project-customers',
  RULE_BASED = 'rule-based',
}
